import { createApp } from "vue";
import Router from "@/router/Router";
import ComputerInfor from "@/ComputerInfor.vue";

createApp(ComputerInfor).use(Router).mount("#computerinfor");
